import {Option} from 'app/fragment/departure/departure-information/form/select/departure-select.component';
import {ProvisionalAgreement} from './provisional-agreement';

interface ProvisionalAgreementMetadata {
  displayName: string;
}

export const PROVISIONAL_AGREEMENT_METADATA: Record<ProvisionalAgreement, ProvisionalAgreementMetadata> = {
  [ProvisionalAgreement.GIVEN]: {
    displayName: 'Given'
  },
  [ProvisionalAgreement.NOT_GIVEN]: {
    displayName: 'Not Given'
  },
  [ProvisionalAgreement.REQUESTED]: {
    displayName: 'Requested'
  },
  [ProvisionalAgreement.NOT_REQUESTED]: {
    displayName: 'Not Requested'
  },
  [ProvisionalAgreement.NOT_APPLICABLE]: {
    displayName: 'Not Applicable'
  },
  [ProvisionalAgreement.UNKNOWN]: {
    displayName: 'Unknown'
  }
};

/**
 * The list of options for Provisional Agreement types. This is used in the search filter sidebar and defines the order
 * and then defers to {@link PROVISIONAL_AGREEMENT_METADATA} for the display names.
 */
export const PROVISIONAL_AGREEMENT_OPTIONS: Option<string>[] = [
  ProvisionalAgreement.GIVEN,
  ProvisionalAgreement.NOT_GIVEN,
  ProvisionalAgreement.REQUESTED,
  ProvisionalAgreement.NOT_REQUESTED,
  ProvisionalAgreement.NOT_APPLICABLE,
  ProvisionalAgreement.UNKNOWN
].map((provisionalAgreement: ProvisionalAgreement) => {
  return {
    value: provisionalAgreement,
    displayName: PROVISIONAL_AGREEMENT_METADATA[provisionalAgreement].displayName
  };
});

/**
 * Returns true if the given criticality is a level suitable for provisional agreement to be requested/reviewed on the
 * departure.
 */
export function isProvisionalAgreementValidForCriticality(criticality: string): boolean {
  return ['3', '4', '5'].includes(criticality);
}
